(function ($, Promise) {

    // Constructor
    function VICCMap(el) {
      this.$el = $(el);
      this.api = new VICCCloudAPI();

      this.map = false;
      this.marker = false;
      this.autocomplete = false;

      this.lat = false;
      this.lng = false;
      this.place = false;
      this.originalUrl = false;

      // CTA open differently at this point
      this.responsiveBreakpoint = 1000;
      this.firstSearch = true;

      // Used to offset marker center
      this.mapCenterPosition = 0;

      this.initTrigger();
    }

    VICCMap.prototype.initTrigger = function () {
      // Empty and reset Map CTA
      $(".map-location-field .delete-button", this.$el).off("click").on("click", $.proxy(function () {
        this.closeCTA();
        $(".delete-button", this.$el).removeClass("not-empty");
        $(".map-location-field input.pac-target-input", this.$el).val("").blur();
      }, this));

      // Add/Remove X on input change
      $(".input-autocomplete", this.$el).off("input").on("input", function (e) {
        $(".delete-button", this.$el).toggleClass("not-empty", $(e.currentTarget).val() !== "");
      });
    };

    VICCMap.prototype.initMap = function (initialMapPosition) {

      initialMapPosition = (typeof initialMapPosition == "undefined") ? {} : initialMapPosition;

      var mapPosition = $.extend({
        zoom: 2,
        center: {lat: 25, lng: 0},
        markerPosition: false,
      }, initialMapPosition);

      this.geocoder = new google.maps.Geocoder();

      var mapEl = $(".map", this.$el).get(0);
      this.map = new google.maps.Map(mapEl, {
        center: mapPosition.center,
        zoom: mapPosition.zoom,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'cooperative',
        restriction: {
          latLngBounds: {north: 85, south: -85, west: -180, east: 180},
          strictBounds: true
        }
      });

      // Google auto-complete options
      var autocompleOptions = {
        // componentRestrictions: { country: "us" },
        fields: ["formatted_address", "geometry", "name"],
        origin: this.map.getCenter(),
        strictBounds: false,
        types: ["geocode", "establishment"],
        language: app.language,
      };

      // Create the autocomplete object
      // https://developers.google.com/maps/documentation/javascript/places-autocomplete
      var inputEl = $(".input-autocomplete", this.$el).get(0);
      this.autocomplete = new google.maps.places.Autocomplete(inputEl, autocompleOptions);
      // this.autocomplete.bindTo("bounds", this.map);
      this.autocomplete.addListener("place_changed", $.proxy(this.updatedPlaceInput, this));
      selectFirstPredictionOnEnter(inputEl);

      // Create Marker
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        icon: {
          url: "/images/icons/pin.svg",
          size: new google.maps.Size(56, 56),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(28, 28),
        },
      });

      if (mapPosition.markerPosition) {
        this.marker.setPosition(mapPosition.markerPosition);
      }

      // Trigger search when dragging marker
      this.marker.addListener('dragend', $.proxy(this.draggedMarker, this));

      // Trigger search when clicking on map
      google.maps.event.addListener(this.map, 'click', $.proxy(function (event) {

        // Synchronize (marker position)
        if (this.$el.is("#main-map-wrapper")) {
          app.components.visualize.tryAnotherAddress.setPosition(false, false, event.latLng);
        } else if (this.$el.is("#overlay-map-wrapper") && app.components.visualize.mainMap) {
          app.components.visualize.mainMap.marker.setPosition(event.latLng);
        }

        this.marker.setPosition(event.latLng);
        this.draggedMarker();
        // placeMarker(event.latLng);

      }, this));

      // Trigger search on focus
      $(".map-location-field input", this.$el).off("focus").on("focus", $.proxy(this.placeInputFocus, this));

      // Trigger search using button, get place using geocoder
      $(document).off("click.searchButton").on("click.searchButton", ".map-location-field .search-button", $.proxy(function () {
        var firstValue = "";

        $(inputEl).blur();

        if ($(".pac-container .pac-item:first span:eq(3)").text() == "") {
          firstValue = $(".pac-container .pac-item:first .pac-item-query").text();
        } else {
          firstValue = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:eq(3)").text();
        }

        // Update value of input and trigger search
        if (firstValue) {
          $(inputEl).val(firstValue);

          this.geocoder.geocode({"address": firstValue}, $.proxy(function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              // Trigger search
              this.updatedPlaceInput(results[0]);
            }
          }, this));
        }

      }, this));
    }

    VICCMap.prototype.updatedPlaceInput = function (place = {}) {

      // infowindow.close();
      this.marker.setVisible(false);
      if (Object.keys(place).length >= 1) {
        this.place = place;
      } else {
        this.place = this.autocomplete.getPlace();
      }

      if (!this.place.geometry || !this.place.geometry.location) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        // This should never happen, search button and ENTER key both use autocomplete to trigger the search
        console.log("No details available for input: '" + this.place.name + "'");
        return;
      }

      // Zoom and center in map
      this.map.setZoom(17); // setting zoom after setCenter seem to cause problems
      this.map.setCenter(mapGetCenter(this.map, this.place.geometry.location, this.mapCenterPosition, 0));

      this.marker.setPosition(this.place.geometry.location);
      this.marker.setVisible(true);

      if (this.place.geometry.viewport) {
        this.lat = this.place.geometry.viewport.getCenter().lat();
        this.lng = this.place.geometry.viewport.getCenter().lng();
      } else {
        this.lat = this.place.geometry.location.lat();
        this.lng = this.place.geometry.location.lng();
      }

      this.placename = this.place.formatted_address;

      this.bringInCTA();

      // Update Address
      this.updateAddress(this.placename);

      // Synchronize (location & marker)
      // Update overlay map (location & marker)
      if (this.$el.is("#main-map-wrapper")) {

        app.components.visualize.tryAnotherAddress.setPosition(17, mapGetCenter(this.map, this.place.geometry.location, this.mapCenterPosition, 0), this.place.geometry.location);

      } else if (this.$el.is("#overlay-map-wrapper") && app.components.visualize.mainMap) {

        // Update main map (location & marker)
        app.components.visualize.mainMap.map.setZoom(17); // setting zoom after setCenter seem to cause problems
        app.components.visualize.mainMap.map.setCenter(mapGetCenter(this.map, this.place.geometry.location, this.mapCenterPosition, 0));

        app.components.visualize.mainMap.marker.setPosition(this.place.geometry.location);
        app.components.visualize.mainMap.marker.setVisible(true);

      }
    }

    VICCMap.prototype.updatePreviewImage = function (responseJSON) {

      if (responseJSON == false || responseJSON.hasImagery == false) {
        console.warn("No imagery available from Google Street View.");

        $("#main-map-wrapper .map-cta-preview, #overlay-map-wrapper .map-cta-preview").css("background", "#f1dada");
        $("#main-map-wrapper .cta-button, #overlay-map-wrapper .cta-button").addClass("disabled");
        $("#main-map-wrapper .map-cta-message, #overlay-map-wrapper .map-cta-message").removeClass("hidden");
      } else {
        // Save original url
        this.originalUrl = responseJSON.originalUrl;

        // Add original image
        $("#main-map-wrapper .map-cta-preview, #overlay-map-wrapper .map-cta-preview").css("background", "url(" + responseJSON.originalUrl + ") no-repeat center center");
        $("#main-map-wrapper .map-cta-preview, #overlay-map-wrapper .map-cta-preview").css("background-size", "cover");

        $("#main-map-wrapper .cta-button, #overlay-map-wrapper .cta-button").removeClass("disabled");
        $("#main-map-wrapper .map-cta-message, #overlay-map-wrapper .map-cta-message").addClass("hidden");
      }

      $("#main-map-wrapper .map-cta-preview, #overlay-map-wrapper .map-cta-preview").removeClass("loading-streeview");
    }

    VICCMap.prototype.draggedMarker = function () {

      // If the place has a geometry, then present it on a map.
      // map.setCenter(marker.getPosition());
      // map.setZoom(17);

      // Synchronize (marker position and map centering)
      if (this.$el.is("#main-map-wrapper")) {
        app.components.visualize.tryAnotherAddress.setPosition(17, this.marker.getPosition(), mapGetCenter(this.map, this.marker.getPosition(), this.mapCenterPosition, 0));

      } else if (this.$el.is("#overlay-map-wrapper") && app.components.visualize.mainMap) {
        app.components.visualize.mainMap.marker.setPosition(this.marker.getPosition());
        app.components.visualize.mainMap.map.setCenter(mapGetCenter(this.map, this.marker.getPosition(), this.mapCenterPosition, 0));
      }

      if (this.map.zoom < 4) {
        this.map.setZoom(5);
      }

      var zoomAnimaton = {
        // zoom: this.map.zoom,
        lat: this.map.getCenter().lat(),
        lng: this.map.getCenter().lng(),
      };
      gsap.to(zoomAnimaton, {
        // zoom: 8,
        lat: mapGetCenter(this.map, this.marker.getPosition(), this.mapCenterPosition, 0).lat(),
        lng: mapGetCenter(this.map, this.marker.getPosition(), this.mapCenterPosition, 0).lng(),
        immediateRender: false,
        onUpdate: $.proxy(function () {
          this.map.setCenter({lat: zoomAnimaton.lat, lng: zoomAnimaton.lng});
        }, this),
        callbackScope: this,
        duration: 1,
      })

      this.lat = this.marker.getPosition().lat();
      this.lng = this.marker.getPosition().lng();

      this.geocoder.geocode({
        location: {
          lat: parseFloat(this.lat),
          lng: parseFloat(this.lng),
        }
      }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.placename = results[0].formatted_address;

            // Update Address
            this.updateAddress(this.placename);
          } else {
            console.warn("No results found");

            // Remove address in breadcrumb
            //$("#visualize-breadcrumb .breadcrumb-item-address-value").text();
          }
        } else {
          console.warn("Geocoder failed due to: " + status);
        }

        // Bring in next step CTA
        this.bringInCTA();

      });
    }

    VICCMap.prototype.updateAddress = function (address) {
      // Prevent from going back to current visualization
      $("#overlay-map-wrapper .close-overlay").addClass("hidden");

      // Update address in CTA infos
      $(".map-cta-location-info").html(address);

      // Updated address in search input
      $("#main-map-wrapper .input-autocomplete, #overlay-map-wrapper .input-autocomplete").val(address);

      // Update address in breadcrumb
      $("#visualize-breadcrumb .breadcrumb-item-address-value").fadeOut("200", function () {
        $(this).siblings("span:not(.breadcrumb-item-address-value)").fadeOut("200", function () {
          $(this).text(address).fadeIn("200");
        });
      });
    }

    VICCMap.prototype.placeInputFocus = function () {
      this.closeCTA();
      //this.userGeolocate();
    }

    // MIGHT BE USEFULL
    // VICCMap.prototype.userGeolocate = function () {
    //   // Bias the autocomplete object to the user's geographical location,
    //   // as supplied by the browser's 'navigator.geolocation' object.
    //   if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition((position) => {
    //       const geolocation = {
    //         lat: position.coords.latitude,
    //         lng: position.coords.longitude,
    //       };
    //       const circle = new google.maps.Circle({
    //         center: geolocation,
    //         radius: position.coords.accuracy,
    //       });
    //       this.autocomplete.setBounds(circle.getBounds());
    //     });
    //   }
    // }

    VICCMap.prototype.clearCTA = function () {
      $(".map-cta-preview", this.$el).css("background", "none");
      $(".map-cta-message", this.$el).addClass("hidden");
      this.originalUrl = false;
    }

    VICCMap.prototype.bringInCTA = function () {
      this.clearCTA();

      if (!this.$el.is("#overlay-map-wrapper") && window.viewport().width <= this.responsiveBreakpoint) {

        // Animate height and scrollTo
        gsap.to("#map-cta-wrapper", 0.5, {
          height: $("#map-cta-wrapper .map-cta").outerHeight()
        });
        $("#map-cta-wrapper").removeClass("hidden");

        // Only scroll on first search
        if (this.firstSearch) {
          this.firstSearch = false;

          // Scroll to section
          VICC.prototype.scrollTo("#map-cta-wrapper");
        }

      } else if (this.$el.is("#overlay-map-wrapper") && window.viewport().width <= this.responsiveBreakpoint) {

        // Animate height and scrollTo
        gsap.to("#overlay-map-cta-wrapper", 0.5, {
          height: $("#overlay-map-cta-wrapper .map-cta").outerHeight(),
        });

        $("#overlay-map-cta-wrapper").removeClass("hidden");

        // Show CTA in overlay map
        $("#overlay-map-wrapper .map-cta").css({
          "transform": "translate(0,0)",
          "opacity": "1",
          "visibility": "inherit",
        });

        // Only scroll on first search
        if (this.firstSearch) {
          this.firstSearch = false;

          // Scroll to section
          gsap.to("#overlay-map-wrapper", 0.5, {
            scrollTop: $("#overlay-map-cta-wrapper").position().top,
          });
        }

      } else {

        $.each($("#main-map-wrapper .map-cta, #overlay-map-wrapper .map-cta"), function (index, el) {
          if (!$(el).is(".shown")) {
            gsap.fromTo($(el), {
              y: -50,
            }, {
              autoAlpha: 1,
              duration: 0.5,
              y: 0,
            });
          }
        });

      }

      $("#main-map-wrapper .map-cta-location-info, #overlay-map-wrapper .map-cta-location-info").text(this.placename);
      $("#main-map-wrapper .map-cta, #overlay-map-wrapper .map-cta").addClass("shown");
      $("#main-map-wrapper .delete-button, #overlay-map-wrapper .delete-button").addClass("not-empty");

      // Request address preview
      $("#main-map-wrapper .map-cta-preview, #overlay-map-wrapper .map-cta-preview").addClass("loading-streeview");

      this.api.requestPreview(this.lat, this.lng)
        .then($.proxy(this.updatePreviewImage, this))
        .catch($.proxy(function () {
          this.updatePreviewImage(false);
        }, this));

      // Tigger event
      $(this).trigger("selectAddress");
    }

    VICCMap.prototype.closeCTA = function () {

      // When smaller than 1000px
      if (window.viewport().width <= this.responsiveBreakpoint) {

        // Overlay map
        if (this.$el.is("#overlay-map-wrapper")) {

          gsap.to("#overlay-map-cta-wrapper", 0.5, {
            height: 0,
            onComplete: $.proxy(function () {
              this.clearCTA();
            }, this),
          });

        } else if (this.$el.is("#main-map-wrapper")) {
          // Main map

          // Animate height
          $("#map-cta-wrapper").addClass("hidden");

          if ($("#disaster-wrapper #disaster-selector").is(".hidden")) {
            gsap.to("#map-cta-wrapper", 0.5, {
              height: 0,
              onComplete: $.proxy(function () {
                this.clearCTA();
              }, this),
            });
          } else {
            $(".delete-button", this.$el).removeClass("not-empty");
          }
        }
      } else if ($(".map-cta", this.$el).hasClass("shown")) {
        // Both maps on desktop

        gsap.to($(".map-cta", this.$el), {
          autoAlpha: 0,
          duration: 0.5,
          y: -50,
          onComplete: $.proxy(function () {
            this.clearCTA();
          }, this),
          callbackScope: this,
        });

      }

      $(".map-cta", this.$el).removeClass("shown");
    }

    VICCMap.prototype.destroy = function () {
      this.map.setZoom(2);
      this.lat = false;
      this.lng = false;
      this.place = false;
      this.originalUrl = false;
      $("#main-map-wrapper .map-cta-preview, #overlay-map-wrapper .map-cta-preview").css("background", "none");
    }

    // modified version of : https://stackoverflow.com/a/10722973
    function mapGetCenter(map, latlng, offsetx, offsety) {

      var point1 = map.getProjection().fromLatLngToPoint(
        (latlng instanceof google.maps.LatLng) ? latlng : map.getCenter()
      );

      var point2 = new google.maps.Point(
        ((typeof (offsetx) == 'number' ? offsetx : 0) / Math.pow(2, map.getZoom())) || 0,
        ((typeof (offsety) == 'number' ? offsety : 0) / Math.pow(2, map.getZoom())) || 0
      );

      // return modified lat/lng
      return map.getProjection().fromPointToLatLng(new google.maps.Point(
        point1.x - point2.x,
        point1.y + point2.y
      ));
    }

    // https://gist.github.com/Razenbull/a62527cedba864e24f08
    function selectFirstPredictionOnEnter(input) {
      // store the original event binding function
      var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

      function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.

        if (type == 'keydown') {
          var orig_listener = listener;

          listener = function (event) {
            var suggestion_selected = $(".pac-item-selected").length > 0;

            if (event.which == 13 && !suggestion_selected) {
              var simulated_downarrow = $.Event("keydown", {
                keyCode: 40,
                which: 40
              });

              orig_listener.apply(input, [simulated_downarrow]);
            }

            orig_listener.apply(input, [event]);
          };
        }

        _addEventListener.apply(input, [type, listener]);
      }

      if (input.addEventListener)
        input.addEventListener = addEventListenerWrapper;
      else if (input.attachEvent)
        input.attachEvent = addEventListenerWrapper;
    }

    // Expose VICCMap
    window.VICCMap = VICCMap;

  }
)
(jQuery, Promise);
